import React, {Component} from 'react'
import i18 from '../../i18'
import api from '../../source/api'

class CustomerRules extends Component {
    constructor(props) {
        super(props);
        this.state = {
            config: props.config,
            customerRules: props.customerRules,
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            customerRules: nextProps.customerRules,
        })
    }

    onRemoveRule = (rule) => {
        if (!window.confirm('Biztos törölni szeretné a szabályt?')) {
            return;
        }
        api.delete('customer/' + this.state.config.company_id + '/rule/delete/' + rule.id)
            .then((response) => {
                this.props.updateRules(response.data.customerRules);
                this.props.notifySuccess('Szabály törlése sikeres.')
            })
            .catch((err) => {
                this.props.notifyError('Szabály törlése sikertelen.');
            });
    };

    deleteAllRules = () => {
        if (!window.confirm('Biztos törölni szeretné az összes szabályt?')) {
            return;
        }

        api.delete('customer/' + this.state.config.company_id + '/rules/delete-all')
            .then((response) => {
                this.props.updateRules(response.data.customerRules)
                this.props.notifySuccess('Összes szabály törlése sikeres.')
            })
            .catch((err) => {
                this.props.notifyError('Szabályok törlése sikertelen.');
            });
    }

    renderRulesTableHeader = () => {
        return (
            <tr>
                <th>{i18.COMMON._identifier}</th>
                <th>{i18.CUSTOMER._typeOfTraffic}</th>
                <th>{i18.CUSTOMER._invoiceNumber}</th>
                {this.state.config.positionNumberVisible
                    ? <React.Fragment>
                        <th>{i18.CUSTOMER._positionNumber}</th>
                        <th>{i18.CUSTOMER._positionNumberCountry}</th>
                    </React.Fragment>
                    : null
                }
                <th>{i18.CUSTOMER._mainBookNumber}</th>
                <th>{i18.CUSTOMER._VAT}</th>
                <th>{i18.CUSTOMER._collectorCode}</th>
                <th>{i18.CUSTOMER._taxNumber}</th>
                <th>{i18.CUSTOMER._vatDegreeNumber}</th>
                <th>{i18.COMMON._typeOfRule}</th>
                <th>{i18.COMMON._position}</th>
                <th>{i18.COMMON._updatedAt}</th>
                <th style={{width: '70px'}}></th>
            </tr>
        );
    }

    renderRulesTableRow = (rule) => {
        return <tr key={'customer-rule-' + rule.id}>
            <td>#{rule.id}</td>
            <td>{rule.item_name || '-'}</td>
            <td>{rule.invoice_number || '-'}</td>
            {this.state.config.positionNumberVisible
                ? <React.Fragment>
                    <td>{rule.position_number || '-'}</td>
                    <td>{rule.position_number_country || '-'}</td>
                </React.Fragment>
                : null
            }
            <td>{rule.main_bookkeeping_number}</td>
            <td>{rule.vat}%</td>
            <td>{rule.vat_collector_code}</td>
            <td>{rule.company_type_label}</td>
            <td>{rule.vat_degree}</td>
            <td>{rule.type_label}</td>
            <td>{rule.position}</td>
            <td>{rule.updated_at}</td>
            <td>
                <i onClick={() => this.props.editRule(rule)} title={i18.CUSTOMER._editRule} className='fa fa-pencil-square-o' aria-hidden='true'/> &nbsp;&nbsp;
                <i onClick={() => this.onRemoveRule(rule)} title={i18.CUSTOMER._deleteRule} className='fa fa-trash-o' aria-hidden='true'/>
            </td>
        </tr>;
    };

    render = () => {
        return (
            <section id='customer-rules'>
                <div className='header'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <h1>
                                    <a onClick={() => this.props.toggleRulesPage()} className='choose-btn'>{i18.BUTTONS._back}</a>
                                    {i18.CUSTOMER._rulesTitle}
                                </h1>
                                <h4 className='text-left'>Kiválasztott cég: {this.state.config.company_name}</h4>
                            </div>
                            <div className='col-12'>
                                <p>
                                    {i18.CUSTOMER._rulesDescription}
                                </p>
                                <a className='link-color' onClick={() => this.deleteAllRules()}>
                                    <i className="fa fa-trash-o" aria-hidden="true"/>&nbsp;{i18.COMMON._deleteAllRules}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='body'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <table className='table table-striped table-aibook-no-border table-hover cursor-pointer'>
                                    <thead>
                                    {this.renderRulesTableHeader()}
                                    </thead>
                                    <tbody>
                                    {this.state.customerRules.map((rule) => this.renderRulesTableRow(rule))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default CustomerRules




// WEBPACK FOOTER //
// ./src/components/customer/CustomerRules.js